import { https,httpsFile } from "./http";

export function index(po_header,currentpage,page){
    return https().get(`/po-details?po_header=${po_header}&currentpage=${currentpage}&page=${page}`);
}
export function getQtyBreakdown(po_number,EBELP,MATNR){
    return https().get(`/getQtyBreakdown?po_number=${po_number}&EBELP=${EBELP}&MATNR=${MATNR}`);
}

export function exportDetails(po_number){
    return https().get(`/exportDetails?po_number=${po_number}`);
}

export function poManualExport(id){
    return https().get(`poManualExport?id=${id}`);
}